import "./parallax.css";
import partner1 from "../../../assets/komet-assets/partner1.png";
import partner2 from "../../../assets/komet-assets/partner2.png";
import partner3 from "../../../assets/komet-assets/partner3.png";
import partner4 from "../../../assets/komet-assets/partner4.png";
import partner5 from "../../../assets/komet-assets/partner5.png";
import partner6 from "../../../assets/komet-assets/partner6.png";
import partner7 from "../../../assets/komet-assets/partner7.png";
import partner8 from "../../../assets/komet-assets/partner8.png";

export default function Content() {
    const logos = [
        { src: partner1, alt: "partner1" },
        { src: partner2, alt: "partner2" },
        { src: partner3, alt: "partner3" },
        { src: partner4, alt: "partner4" },
        { src: partner5, alt: "partner5" },
        { src: partner6, alt: "partner6" },
        { src: partner7, alt: "partner7" },
        { src: partner8, alt: "partner8" },
    ];

    return (
        <>
            <div className="lineContent gap-[5rem]">
                {logos.map((logo, index) => (
                    <div key={index} className="logo w-[150px]">
                        <img src={logo.src} alt={logo.alt} className="w-[200px]" />
                    </div>
                ))}
            </div>
        </>
    );
}
